import "./index.css";
import { GameContainer } from "./components/GameContainer";
import { FireButton } from "./components/FireButton";
import { AngleSlider } from "./components/AngleSlider";
import { DebugConsole } from "./components/DebugConsole";
import { EngineControl } from "./components/EngineControl";
import { PlayerBadge } from "./components/PlayerBadge";
import { useWebSocket } from "./hooks/useWebSocket";
import { send } from "./services/websocket-client";
import {
  createEngineControlMessage,
  createShootMessage,
  createPitchControlMessage,
} from "protocol";

export function App() {
  const {
    logs,
    engineOn,
    pitchPosition,
    playerColor,
    addLog,
    setEngineOn,
    setPitchPosition,
  } = useWebSocket();

  const handleFire = () => {
    const message = createShootMessage();
    send(message);
    addLog("Fire!");
  };

  const handleEngineToggle = () => {
    const newState = !engineOn;
    setEngineOn(newState);
    const message = createEngineControlMessage(newState);
    addLog(`Sending: ${JSON.stringify(message)}`);
    send(message);
    addLog(`Engine ${newState ? "started" : "stopped"}`);
  };

  const handlePitchChange = (position: number) => {
    setPitchPosition(position);
    const message = createPitchControlMessage(position);
    send(message);
    addLog(`Pitch set to ${position}`);
  };

  return (
    <GameContainer>
      <PlayerBadge color={playerColor} />
      <FireButton onFire={handleFire} />
      {/* <DebugConsole logs={logs} /> */}
      <EngineControl engineOn={engineOn} onToggle={handleEngineToggle} />
      <AngleSlider pitchPosition={pitchPosition} onChange={handlePitchChange} />
    </GameContainer>
  );
}

export default App;
